import AuthMiddleware from "@/middleware/auth"

const BillingAutomationRules = () =>
  import(
    /* webpackChunkName: "billing-automation-rules" */ "@/components/billingAutomationRules/BillingAutomationRules"
  )

const BillingAutomationRulesRouter = [
  {
    path: "/billing-automation-rules",
    name: "BillingAutomationRules",
    component: BillingAutomationRules,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "BILLING AUTOMATION RULES",
    },
  },
]

export { BillingAutomationRulesRouter }
